/* See https://www.algolia.com/doc/integration/shopify/advanced-customization/customizing-instant-search/#hogan */

(function(algolia) {
  'use strict';
  var Hogan = algolia.externals.Hogan;
  var formatPrice = function formatPrice(value) {
    var rate=  Shopify.currency.rate;  
    const userCurrency = Shopify.currency.active;    
    if(userCurrency=='USD'){
      rate = 1.0;
    }else if(userCurrency=='HKD'){
      rate=rate*1.02;
    }else{
      rate=rate*1.04;
      console.log("Rate:["+userCurrency+"]["+ rate+ "]["+ (rate*1.04)+"]");
    }
    var amt = Math.ceil(Number(value) * rate);
    if(userCurrency=='VND'|| userCurrency=='COP'){
      amt = Math.round((amt+500)/1000)*1000      
    }else if (userCurrency=='PHP' || userCurrency=='JPY'){
      amt = Math.round((amt+50)/100)*100
    }
    return new Intl.NumberFormat(Shopify.locale, { style: 'currency', currency: userCurrency, maximumFractionDigits: 0}).formatToParts(amt).map(val => val.value).join('');  
    //return algolia.formatMoney(Number(value) * 100);
  };

  function formattedPriceWithComparison(price, compare_at_price, price_ratio) {
    var comparing =
      Number(compare_at_price) && Number(compare_at_price) > Number(price);
    var discount_ratio = 1.0 - price_ratio;
    var res = '';
    if (comparing) {
        res = '<b><font style="color:green">' + formatPrice(price) + '</font></b>';    	
    }else{
    	res = '<b>' + formatPrice(price) + '</b>';
    }
    if (comparing) {
      res +=
        ' <span class="ais-hit--price-striked"><span>' +
        formatPrice(compare_at_price) +
        '</span></span> ';
      //res += ' <span class="ais-hit--price-discount" style="font-weight: ' + Math.floor(discount_ratio * 10) * 100 +';">-' + Math.floor(discount_ratio * 100) + '%</span>';
    }

    return res;
  }

  var escapeHtml = function escapeHtml(unsafe) {
    return (unsafe || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');n
  };

  algolia.helpers = {
    formatNumber: function formatNumber(text, render) {
      return Number(render(text)).toLocaleString();
    },
    formattedPrice: function formattedPrice(text, render) {
      return formatPrice(render(text));
    },
    formattedPriceWithoutDecimals: function formattedPriceWithoutDecimals(
      text,
      render
    ) {
      return formatPrice(render(text)).replace(/\.\d+$/, '');
    },
    bestPrice: function bestPrice() {
      if(!this.inventory_available){
        return 'Out of Stock';        
      }        
      var min = this.variants_min_price;
      if (min == 0) {
        min = this.price;
      }      
//       if (this._distinct) {
//         var min = this.variants_min_price;
//         if (min == 0) {
//           min = this.price;
//         }
//       }
      if(min>0){
      	return '<b>From: ' + formattedPriceWithComparison(min,this.compare_at_price,this.price_ratio) + '</b>';        
      }else{
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if(this.inventory_available){
          if(min>0){
          	return formatPrice(min);
          }else if(max>0){
            	return formatPrice(max);
          }
        }
		return 'Out of Stock';        
      }
      
    },     
    autocompletePrice: function autocompletePrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        if(!this.inventory_available){
          return 'Out of Stock';        
        }        
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(this.price, null);
    },
    instantsearchPrice: function instantsearchPrice() {
      if (this._distinct) {
        var min = this.variants_min_price;
        var max = this.variants_max_price;
        console.log("inventory_available:"+inventory_available);
        if(!this.inventory_available){
          return 'Out of Stock';        
        }         
        if (min !== max) {
          return '<b>' + formatPrice(min) + ' - ' + formatPrice(max) + '</b>';
        }
      }
      return formattedPriceWithComparison(
        this.price,
        this.compare_at_price,
        this.price_ratio
      );
    },
    instantsearchLink: function instantsearchLink() {
      const firstPath = location.pathname.split('/')[1];	  
      var language='';
      var addVariantId = !this._distinct && this.objectID !== this.id;
      if(firstPath!='products' && firstPath !='collections' && firstPath !='search'){
      	language = '/'+firstPath;
      }      
      return (
        language + '/products/' +
        this.handle +
        (addVariantId ? '?variant=' + this.objectID : '')
      );
    },
    fullTitle: function fullTitle() {
      var res = this.title;
      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' (' + this.variant_title + ')';
      }
      return escapeHtml(res);
    },
    modelNumber: function fullTitle() {
      var res = this.title;	  
	  var n = res.lastIndexOf(' ');
      var res = res.substring(n + 1);      
      return escapeHtml(res);
    },    
    fullHTMLTitle: function fullHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
      return res;
    },
    fullEscapedAttribute(attribute) {
      return new DOMParser().parseFromString(attribute, 'text/html')
        .documentElement.textContent;
    },
    fullEscapedHTMLTitle: function fullEscapedHTMLTitle() {
      var res = '';

      if (this._highlightResult.title && this._highlightResult.title.value) {
        res = algolia.helpers.fullEscapedAttribute(
          this._highlightResult.title.value
        );
      }

      if (
        !this._distinct &&
        this.variant_title &&
        this.variant_title !== 'Default Title' &&
        this.variant_title !== 'Default'
      ) {
        res += ' <span class="algolia-variant">(' + res + ')</span>';
      }
	  var n = res.lastIndexOf(' ');
      if(n>0){
        res = res.substring(0,n);  
        res = res.replaceAll("<font>","").replaceAll("</font>","");
      }
      return res;
    },
    fullEscapedHTMLProductType: function fullEscapedHTMLProductType() {
      if (
        this._highlightResult.product_type &&
        this._highlightResult.product_type.value
      ) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.product_type.value
        );
      } else {
        return '&nbsp;';
      }
    },
    fullEscapedHTMLVendor: function fullEscapedHTMLVendor() {
      if (this._highlightResult.vendor && this._highlightResult.vendor.value) {
        return algolia.helpers.fullEscapedAttribute(
          this._highlightResult.vendor.value
        );
      } else {
        return '';
      }
    },
    floor: function floor(text, render) {
      return '' + Math.floor(Number(render(text)));
    },
    ceil: function ceil(text, render) {
      return '' + Math.ceil(Number(render(text)));
    },
    sizedImage: function sizedImage(text, render) {
      var image = this._distinct ? this.product_image : this.image;
      if (!image) {
        //return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
        //return 'https://cdn.shopify.com/s/images/themes/product-1_1024x1024.png';
        return '//www.kickscrew.com/cdn/shop/t/52/assets/product-photo_large.png?v=26647922702688335791659632963';        
      }
      var size = render(text).replace(/^\s+|\s+$/g, ''); // Render and trim
      if (size === 'original') {
        return image;
      }
      return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + size + '.$2');
    },
  };

  [
    'pico',
    'icon',
    'thumb',
    'small',
    'compact',
    'medium',
    'large',
    'grande',
    'original',
  ].forEach(function(size) {
    algolia.helpers[size + 'Image'] = (function(_size) {
      return function() {
        var image = this._distinct ? this.product_image : this.image;

        if (!image) {
          //return 'http://cdn.shopify.com/s/images/admin/no-image-compact.gif';
          return '//www.kickscrew.com/cdn/shop/t/52/assets/product-photo_large.png?v=26647922702688335791659632963';
        }

        if (_size === 'original') {
          return image;
        }

        return image.replace(/\/(.*)\.(\w{2,4})/g, '/$1_' + _size + '.$2');
      };
    })(size); // We need to create a new scope so that the internal size has the good value.
  });

  /* Create an Hogan lambda, which doesn't respect the mustache doc */
  var helpers = algolia.assign(
    {},
    algolia.helpers,
    algolia.translation_helpers
  );
  var helpersNames = Object.keys(helpers);
  var i = helpersNames.length;
  var helpersArray = new Array(i);
  while (i--) helpersArray[i] = [helpersNames[i], helpers[helpersNames[i]]];

  algolia.hoganHelpers = helpersArray.reduce(function(res, options) {
    var name = options[0];
    var helper = options[1];

    var newRes = algolia.assign({}, res);

    newRes[name] = function() {
      return function(text) {
        var render = function(value) {
          return Hogan.compile(value, algolia.hoganOptions).render(this);
        }.bind(this);

        return helper.call(this, text, render);
      }.bind(this);
    };

    return newRes;
  }, {});
})(window.algoliaShopify);
